/* eslint @okta/okta/no-specific-modules: 0 */
import Handlebars from 'handlebars';
import _ from '../underscore-wrapper';
import StringUtil from '../StringUtil';

function trim(str) {
  return str && str.replace(/^\s+|\s+$/g, '');
}

Handlebars.registerHelper('i18n', function (options) {
  let params;
  const key = trim(options.hash.code);
  const bundle = trim(options.hash.bundle);
  const args = trim(options.hash['arguments']);

  if (args) {
    params = _.map(
      trim(args).split(';'),
      function (param) {
        param = trim(param);
        let val;
        const data = this;

        /*
       * the context(data) may be a deep object, ex {user: {name: 'John', gender: 'M'}}
       * arguments may be 'user.name'
       * return data['user']['name']
       */
        _.each(param.split('.'), function (p) {
          val = val ? val[p] : data[p];
        });
        return val;
      },
      this
    );
  }

  return StringUtil.localize(key, bundle, params);
});

export default Handlebars;



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/util/handlebars/helper-i18n.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/util/handlebars/helper-i18n.js